import { CircularProgress } from '@mui/material'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useContext } from 'react'
import { AuthContext } from '../utils/context/auth.context'

export const Route = createFileRoute('/')({
  component: IndexComponentPage,
})

function IndexComponentPage() {
  const { authenticated, isLoading, hasRights } = useContext(AuthContext)

  if (isLoading) {
    return <CircularProgress /> // TODO :center ?
  }

  if (authenticated) {
    if (hasRights(['READER'])) {
      return <Navigate to="/dashboard" replace />
    }
    if (hasRights(['STOCK_READER'])) {
      return <Navigate to="/stores" replace />
    }
    if (hasRights(['ACCOUNTING_READER'])) {
      return <Navigate to="/accounting" replace />
    }
    return <Navigate to="/dashboard" replace />
  }

  return <Navigate to="/login" replace />
}
